export const UPDATE_PARTS_STATUS = 'UPDATE_PARTS_STATUS'
export const UPDATE_PARTS_STATUS_SUCCESS = 'UPDATE_PARTS_STATUS_SUCCESS'
export const UPDATE_PARTS_STATUS_FAIL = 'UPDATE_PARTS_STATUS_FAIL'
export const CREATE_PARTS_QUANTITIES = 'CREATE_PARTS_QUANTITIES'
export const CREATE_PARTS_QUANTITIES_SUCCESS = 'CREATE_PARTS_QUANTITIES_SUCCESS'
export const CREATE_PARTS_QUANTITIES_FAIL = 'CREATE_PARTS_QUANTITIES_FAIL'
export const GET_PART_CONFIG_OPTIONS = 'GET_PART_CONFIG_OPTIONS'
export const GET_PART_CONFIG_OPTIONS_SUCCESS = 'GET_PART_CONFIG_OPTIONS_SUCCESS'
export const GET_PART_CONFIG_OPTIONS_FAIL = 'GET_PART_CONFIG_OPTIONS_FAIL'
export const UPDATE_PARTS = 'UPDATE_PARTS'
export const UPDATE_PARTS_SUCCESS = 'UPDATE_PARTS_SUCCESS'
export const UPDATE_PARTS_FAIL = 'UPDATE_PARTS_FAIL'
export const GET_OFFER_FILTERED_PARTS = 'GET_OFFER_FILTERED_PARTS'
export const GET_OFFER_FILTERED_PARTS_SUCCESS = 'GET_OFFER_FILTERED_PARTS_SUCCESS'
export const GET_OFFER_FILTERED_PARTS_FAIL = 'GET_OFFER_FILTERED_PARTS_FAIL'
export const GET_ORDER_FILTERED_PARTS = 'GET_ORDER_FILTERED_PARTS'
export const GET_ORDER_FILTERED_PARTS_SUCCESS = 'GET_ORDER_FILTERED_PARTS_SUCCESS'
export const GET_ORDER_FILTERED_PARTS_FAIL = 'GET_ORDER_FILTERED_PARTS_FAIL'
export const GET_PARTS_STEP_ANALYSIS_BY_PARTS_IDS = 'GET_PARTS_STEP_ANALYSIS_BY_PARTS_IDS'
export const GET_PARTS_STEP_ANALYSIS_BY_PARTS_IDS_SUCCESS = 'GET_PARTS_STEP_ANALYSIS_BY_PARTS_IDS_SUCCESS'
export const GET_PARTS_STEP_ANALYSIS_BY_PARTS_IDS_FAIL = 'GET_PARTS_STEP_ANALYSIS_BY_PARTS_IDS_FAIL'
export const CREATE_PART_STEP_ANALYSIS = 'CREATE_PART_STEP_ANALYSIS'
export const CREATE_PART_STEP_ANALYSIS_SUCCESS = 'CREATE_PART_STEP_ANALYSIS_SUCCESS'
export const CREATE_PART_STEP_ANALYSIS_FAIL = 'CREATE_PART_STEP_ANALYSIS_FAIL'
export const GET_SIMILAR_PARTS_DETAIL = 'GET_SIMILAR_PARTS_DETAIL'
export const GET_SIMILAR_PARTS_DETAIL_SUCCESS = 'GET_SIMILAR_PARTS_DETAIL_SUCCESS'
export const GET_SIMILAR_PARTS_DETAIL_FAIL = 'GET_SIMILAR_PARTS_DETAIL_FAIL'
export const UPDATE_BINDING_NOTES = 'UPDATE_BINDING_NOTES'
export const UPDATE_BINDING_NOTES_SUCCESS = 'UPDATE_BINDING_NOTES_SUCCESS'
export const UPDATE_BINDING_NOTES_FAIL = 'UPDATE_BINDING_NOTES_FAIL'
export const DELETE_BINDING_NOTES = 'DELETE_BINDING_NOTES'
export const DELETE_BINDING_NOTES_SUCCESS = 'DELETE_BINDING_NOTES_SUCCESS'
export const DELETE_BINDING_NOTES_FAIL = 'DELETE_BINDING_NOTES_FAIL'
export const GET_TECHNOLOGIES_DASHBOARD = 'GET_TECHNOLOGIES_DASHBOARD'
export const GET_TECHNOLOGIES_DASHBOARD_SUCCESS = 'GET_TECHNOLOGIES_DASHBOARD_SUCCESS'
export const GET_TECHNOLOGIES_DASHBOARD_FAIL = 'GET_TECHNOLOGIES_DASHBOARD_FAIL'
export const GET_PARTS_PREDICTS_AND_REAL = 'GET_PARTS_PREDICTS_AND_REAL'
export const GET_PARTS_PREDICTS_AND_REAL_SUCCESS = 'GET_PARTS_PREDICTS_AND_REAL_SUCCESS'
export const GET_PARTS_PREDICTS_AND_REAL_FAIL = 'GET_PARTS_PREDICTS_AND_REAL_FAIL'
export const ANALYZE_STEP_ONSHAPE = 'ANALYZE_STEP_ONSHAPE'
export const ANALYZE_STEP_ONSHAPE_FAIL = 'ANALYZE_STEP_ONSHAPE_FAIL'
export const ANALYZE_STEP_ONSHAPE_SUCCESS = 'ANALYZE_STEP_ONSHAPE_SUCCESS'
export const ANALYZE_STEP_OPENCASCADE = 'ANALYZE_STEP_OPENCASCADE'
export const ANALYZE_STEP_OPENCASCADE_FAIL = 'ANALYZE_STEP_OPENCASCADE_FAIL'
export const ANALYZE_STEP_OPENCASCADE_SUCCESS = 'ANALYZE_STEP_OPENCASCADE_SUCCESS'
export const DELETE_PART_STEP_ANALYSIS = 'DELETE_PART_STEP_ANALYSIS'
export const DELETE_PART_STEP_ANALYSIS_FAIL = 'DELETE_PART_STEP_ANALYSIS_FAIL'
export const DELETE_PART_STEP_ANALYSIS_SUCCESS = 'DELETE_PART_STEP_ANALYSIS_SUCCESS'
export const UPLOAD_AND_CONVERT_TO_STEP = 'UPLOAD_AND_CONVERT_TO_STEP'
export const UPLOAD_AND_CONVERT_TO_STEP_FAIL = 'UPLOAD_AND_CONVERT_TO_STEP_FAIL'
export const UPLOAD_AND_CONVERT_TO_STEP_SUCCESS = 'UPLOAD_AND_CONVERT_TO_STEP_SUCCESS'
